var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassifieds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5377 6.66455H8.51221V11.9682H11.5377V6.66455Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9818 9.6897H3.17285V12.7513H6.9818V9.6897Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23472 5.94971H2.42578V8.22786H6.23472V5.94971Z",
    fill: "#82AA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6102 3.43198H10.4303L6.99836 0L3.56638 3.43198H1.38656C0.622805 3.43198 0 4.05151 0 4.81854V13.9148C0 14.6785 0.619527 15.3013 1.38656 15.3013H12.6134C13.3772 15.3013 14 14.6818 14 13.9148V4.81854C13.9967 4.05151 13.3772 3.43198 12.6102 3.43198ZM6.99836 1.62257L8.80777 3.43198H5.18895L6.99836 1.62257ZM12.5872 13.9213H1.40951V4.80871H12.5872V13.9213Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassifieds);
export default __webpack_public_path__ + "static/media/classifieds.420b0f4ffc24deb9090af28373632052.svg";
export { ForwardRef as ReactComponent };